import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class MessagingService {
  url: any;
  currentMessage = new BehaviorSubject(null);
  constructor(private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    )
  }

  
  requestPermission() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('TL/firebase-messaging-sw.js')
        .then(function(registration) {
          // console.log('Registration successful, scope is:', registration.scope);
        }).catch(function(err) {
          // console.log('Service worker registration failed, error:', err);
        });
      }
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        // console.log(token);
        sessionStorage.setItem('fcmToken', token);
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        // console.log("new message received. ", payload);
        this.currentMessage.next(payload);
        this.showCustomNotification(payload);
      })
  }

  showCustomNotification(payload: any){
    let notify_data = payload ['notification'];
    let title = notify_data['title'];
    let options={
      body: notify_data['body'],
      icon: "./assets/images/logo.png",
      badge: "./assets/images/logo.png",
      // image: "./assets/images/logo.png"
    };
    
    // console.log("New message received.", notify_data)
    let notify: Notification = new Notification(title,options)
    
    notify.onclick = event=>{
      event.preventDefault();
      this.url='https://www.google.com';
      var win = window.open(this.url, '_blank');
       win.focus();
      // window.location.href='https://www.google.com';
    }
    }
}
